import React from 'react';
import HelpContent from './HelpContent';
import proyeccionParticipacion from 'img/proyeccion_participacion.png';

const CalefaccionDistritalHelp = () => (
  <HelpContent>
    <h1>Energía distrital</h1>
    <p>
      En Chile, la implementación de un sistema de energía distrital se presenta como una medida de mitigación efectiva para reducir tanto la 
      contaminación atmosférica en zonas urbanas como las emisiones de CO2 del sector de calor y frío. La energía distrital ofrece beneficios como 
      una mayor eficiencia energética, el uso de recursos renovables, una mejor calidad del aire tanto en la ciudad como en el interior de los hogares 
      y una reducción de los costos de calefacción para los usuarios, entre otros. 
    </p>
    <p>
    <strong>Trayectoria 1:</strong>  en 2030 hay 10.000 viviendas conectadas a una red de energía distrital, y aumentan a una tasa de 10.000 hogares por año hasta 2050 (210.000 hogares conectados).
    </p>
  </HelpContent>
);

export default CalefaccionDistritalHelp;
